import { api } from "./client";

export interface Message {
  id: string;
  vessel_id: string | null;
  sender_id: string;
  sender_email: string;
  sender_name: string | null;
  recipient_id: string | null;
  subject: string;
  body: string;
  priority: "normal" | "urgent";
  read_at: string | null;
  created_at: string;
}

export interface VesselMessage {
  id: string;
  vessel_id: string;
  vessel_name: string;
  sender_name: string;
  sender_email: string;
  subject: string;
  body: string;
  priority: "normal" | "urgent";
  read_at: string | null;
  created_at: string;
}

export const messagesApi = {
  list: (params?: { vesselId?: string; limit?: number; before?: string }) => {
    const qs = new URLSearchParams();
    if (params?.vesselId) qs.set("vesselId", params.vesselId);
    if (params?.limit)    qs.set("limit", String(params.limit));
    if (params?.before)   qs.set("before", params.before);
    return api.get<Message[]>(`/api/messages?${qs}`);
  },

  listVesselMessages: (params?: { vesselId?: string; limit?: number }) => {
    const qs = new URLSearchParams();
    if (params?.vesselId) qs.set("vesselId", params.vesselId);
    if (params?.limit)    qs.set("limit", String(params.limit));
    return api.get<VesselMessage[]>(`/api/messages/vessel-messages?${qs}`);
  },

  get: (id: string) => api.get<Message>(`/api/messages/${id}`),

  send: (body: {
    vesselId?: string;
    recipientId?: string;
    subject: string;
    body: string;
    priority?: "normal" | "urgent";
  }) => api.post<{ id: string }>("/api/messages", body),

  markRead: (id: string) => api.patch<{ ok: boolean }>(`/api/messages/${id}/read`, {}),
};
